/**
 * Created by hp on 2017/8/8.
 */
import React, {Component} from 'react';
import ChannelPopularTitle from '../images/yx-title.png';
import ChannelPopularBg from '../images/yx-bg.png';
import '../styles/PopularBar.css';

class ChannelPopular extends Component {
    render() {
        const {prefferedReason} = this.props;

        return (
            <div className="popular-bar">
                <div className="cp-inner">
                    <div className="cp-inner-left">
                        <div className="cp-content">
                            <p className="cpt-text">{prefferedReason}</p>
                        </div>
                    </div>
                    <div className="cpt-img">
                        <img src={ChannelPopularBg}/>
                    </div>
                </div>
            </div>
        )
    }
}

export default ChannelPopular;


// WEBPACK FOOTER //
// ./src/components/PopularBar.js